<div class="max-w-[1440px] h-20 mx-auto flex justify-between items-center px-6 md:px-5 lg:px-[150px]">

  <!--logo-->
  <a (click)="onNav('')" target="_blank" rel="noopener noreferrer" class="flex flex-row items-end cursor-pointer">
    <svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.85004 23.564H15.07V30.3472H0V0.884766H7.85004V23.564Z" fill="#F5375C" />
    </svg>

    <div class="flex flex-col items-center">
      <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.800781 2.67866C0.800781 1.43116 1.6108 0.661223 2.8808 0.612493C4.2208 0.573508 5.00079 1.51888 5.00079 2.59095C5.00079 3.73125 4.38083 4.63763 2.79083 4.63763C1.64083 4.63763 0.810781 3.79946 0.800781 2.67866Z"
          fill="#F5375C" />
      </svg>
      <svg width="8" height="23" viewBox="0 0 8 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.45062 22.3632H0.430603C0.410603 22.0806 0.390625 21.8369 0.390625 21.5933V2.3642C0.390625 1.33111 0.870603 0.873047 1.9306 0.873047H5.9906C6.8406 0.873047 7.44062 1.36035 7.45062 2.12055C7.47062 8.86485 7.45062 15.5897 7.45062 22.373V22.3632Z"
          fill="#F5375C" />
      </svg>
    </div>

    <svg width="51" height="23" viewBox="0 0 51 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M37.81 22.3943C37 18.5544 36.2 14.7534 35.34 10.7088C34.63 14.1394 33.96 17.3459 33.31 20.5523C33.29 20.6011 33.29 20.679 33.29 20.7278C33.0167 21.8518 32.2867 22.4138 31.1 22.4138H25.38C24.71 19.8214 24.04 17.2971 23.42 14.7729C22.86 12.4631 22.38 10.1143 21.81 7.78493C21.39 5.92343 20.87 4.1204 20.36 2.20041C20.06 3.09705 19.78 3.8475 19.55 4.63694C19.09 6.15733 18.67 7.70696 18.24 9.24685C17.73 11.0889 17.23 12.9211 16.7 14.7631C16.31 16.0789 15.87 17.3751 15.48 18.6908C15.22 19.5875 15 20.4744 14.76 21.371C14.6 21.946 14.48 22.4528 13.61 22.4236C11.56 22.3554 9.49999 22.3846 7.42999 22.4041C6.91999 22.4041 6.75999 22.1897 6.62 21.7511C6.02 19.6849 5.37002 17.6188 4.77002 15.5526C4.24002 13.7106 3.78002 11.8783 3.27002 10.0363C2.95002 8.8765 2.56004 7.74595 2.23004 6.58616C1.79004 5.07551 1.40002 3.55512 0.960022 2.05422C0.850022 1.68387 0.68 1.32326 0.5 0.913927H8.07001C8.88001 4.89034 9.71 8.88624 10.56 13.0381C11.16 10.3189 11.72 7.78493 12.25 5.2217C12.51 3.9742 12.76 2.73645 12.94 1.46945C13.01 0.943165 13.24 0.855453 13.68 0.855453C18.06 0.855453 22.43 0.874945 26.81 0.855453C27.34 0.855453 27.52 1.06987 27.59 1.51819C28.05 3.97421 28.53 6.40099 28.97 8.83752C29.18 9.9973 29.36 11.1668 29.66 12.3364C30.15 9.63669 30.63 6.95651 31.12 4.25684C31.3 3.27248 31.46 2.31737 31.67 1.35251C31.72 1.15758 32.02 0.894434 32.23 0.874941C34.14 0.835957 36.06 0.835957 37.96 0.874941C38.15 0.874941 38.47 1.15758 38.51 1.35251C38.9 3.17503 39.22 5.01704 39.6 6.82007C40.01 8.66209 40.46 10.4846 41.01 12.3364C41.42 9.89984 41.8 7.46331 42.23 5.03653C42.44 3.80852 42.67 2.58051 42.95 1.37199C43 1.15758 43.3 0.88469 43.5 0.88469C45.76 0.845705 48.02 0.865201 50.45 0.865201C50.22 1.8788 50.06 2.82416 49.83 3.7403C49.25 6.08911 48.61 8.41843 48.05 10.7672C47.5 13.0283 46.99 15.2992 46.46 17.5798C46.12 19.0027 45.77 20.4159 45.38 21.8193C45.31 22.0435 44.94 22.3456 44.71 22.3651C42.42 22.4138 40.1 22.4041 37.78 22.4041L37.81 22.3943Z"
        fill="#F5375C" />
    </svg>

    <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.0997 13.9918H7.85966C8.10966 17.1106 11.8497 18.4458 15.1597 15.4635C16.2197 16.8279 17.2597 18.1924 18.2997 19.5666C16.6897 21.3891 14.7197 22.315 12.4197 22.7536C9.99972 23.2117 7.73969 22.7341 5.63969 21.6328C4.48969 21.0383 3.57967 20.0344 2.86967 18.9136C1.20967 16.2724 0.719701 13.3291 0.959701 10.3175C1.1697 7.6861 1.90968 5.15211 3.74968 3.11518C5.01968 1.71174 6.63967 0.678655 8.54967 0.561702C10.1697 0.454495 11.8297 0.279062 13.4697 0.824844C14.7097 1.22443 15.7297 1.89692 16.4997 2.8228C18.3697 5.01567 19.1597 7.60813 19.0597 10.4637C19.0597 11.6235 19.0797 12.7541 19.0797 14.0016L19.0997 13.9918ZM12.3997 9.07005C12.4497 7.31575 11.5497 6.16571 10.2497 6.10723C8.60968 6.0585 8.00967 7.31575 7.86967 9.07005H12.3997Z"
        fill="#F5375C" />
    </svg>

    <svg width="17" height="33" viewBox="0 0 17 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9609 32.4121C12.0109 31.8176 9.17094 31.2718 6.33094 30.6773C5.01094 30.3947 3.68091 30.0438 2.36091 29.7514C1.78091 29.615 1.18091 29.5565 0.610907 29.3811C0.430907 29.3323 0.200912 29.0107 0.240912 28.8548C0.490912 27.5196 0.800949 26.2136 1.09095 24.8979C1.57095 22.6952 2.01092 20.4829 2.50092 18.2803C3.06092 15.795 3.70094 13.3098 4.21094 10.805C4.85094 7.73498 5.43093 4.65521 6.01093 1.57544C6.22093 0.454636 6.57091 0.31819 7.99091 0.66905C10.0009 1.15636 12.0309 1.56569 14.1309 2.01401C14.0109 2.87167 13.9409 3.74882 13.7609 4.58698C13.2709 6.93579 12.7209 9.24562 12.1909 11.5944C11.6109 14.1479 11.0109 16.6916 10.4409 19.2451C10.0909 20.8727 9.80091 22.5003 9.49091 24.1669C11.7509 24.6445 14.0609 25.1123 16.3709 25.5898C15.9109 27.9387 15.4409 30.1998 14.9609 32.4219V32.4121Z"
        fill="#F5375C" />
    </svg>

    <svg width="21" height="32" viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.3894 23.1967C14.7894 22.7971 17.0494 22.4073 19.3794 22.0272C19.7894 24.3078 20.1694 26.5299 20.5994 28.8202C15.6194 29.7168 10.7394 30.594 5.75942 31.5004C5.45942 29.7656 5.15939 28.0698 4.85939 26.3642C4.60939 25.029 4.32943 23.7035 4.07943 22.3683C3.66943 20.1072 3.29944 17.8461 2.90944 15.585C2.67944 14.3083 2.41941 13.0315 2.18941 11.745C1.83941 9.71784 1.49943 7.66141 1.14943 5.63422C1.00943 4.81555 0.779423 3.98713 0.639423 3.14896C0.529423 2.58369 0.709413 2.2913 1.37941 2.1646C3.43941 1.81374 5.50942 1.35568 7.56942 0.97558C8.16942 0.848881 8.48944 1.0438 8.58944 1.74552C8.86944 3.58753 9.29939 5.41006 9.60939 7.23258C10.0994 10.1564 10.5394 13.0997 11.0394 16.0236C11.2994 17.5342 11.6594 19.0059 11.9594 20.4873C12.0994 21.3839 12.2194 22.2416 12.3794 23.187L12.3894 23.1967Z"
        fill="#F5375C" />
    </svg>
  </a>
  <!-- Desktop Menu -->
  <div class="hidden md:flex items-center gap-36">
    <ul class="flex items-center gap-8">
      <li
        class="text-[#121212] font-[manrope]  not-italic font-medium leading-normal cursor-pointer text-sm xl:text-lg transition-colors hover:text-[#f5375c]">
        <a (click)="onNav('')" target="_blank" rel="noopener noreferrer">
          {{"Home" | translate}}
        </a>
      </li>
      <li
        class="group relative text-[#121212]  not-italic font-medium leading-normal  font-[Manrope] cursor-pointer text-sm xl:text-lg transition-colors hover:text-[#f5375c]">

        <!-- Parent Link -->
        <a (click)="onNav('business-insurance')" class="inline-block py-2">
          {{ "For Business" | translate }}
        </a>

        <!-- Dropdown -->
        <ul
          class="absolute left-0 top-full mt-2 w-[300px] bg-white shadow-lg rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
          <li class="px-4 py-3 hover:bg-[#f9f9f9]">
            <a (click)="onNav('business-insurance')" class="block text-[#121212] hover:text-[#f5375c]">
              {{ "All Solutions for Business" | translate }}
            </a>
          </li>

          <li class="px-4 py-3 hover:bg-[#f9f9f9]">
            <a (click)="onNav('one-health')" class="block text-[#121212] hover:text-[#f5375c]">
              {{ "One Health" | translate }}
            </a>
          </li>

        </ul>
      </li>

      <li
        class="group relative text-[#121212]  not-italic font-medium leading-normal font-[Manrope] cursor-pointer text-sm xl:text-lg transition-colors hover:text-[#f5375c]">

        <!-- Parent Link -->
        <a (click)="onNav('individual-insurance')" class="inline-block py-2">
          {{ "For Individual" | translate }}
        </a>

        <!-- Dropdown -->
        <ul
          class="absolute left-0 top-full mt-2 w-[300px] bg-white shadow-lg rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">

          <li class="px-4 py-3 hover:bg-[#f9f9f9]">
            <a (click)="onNav('individual-insurance')" class="block text-[#121212] hover:text-[#f5375c]">
              {{ "All Products for Individual" | translate }}
            </a>
          </li>

          <li class="px-4 py-3 hover:bg-[#f9f9f9]">
            <a (click)="onNav('gym-insurance')" class="block text-[#121212] hover:text-[#f5375c]">
              {{ "Gym Insurance" | translate }}
            </a>
          </li>

          <li class="px-4 py-3 hover:bg-[#f9f9f9]">
            <a (click)="onNav('individual-insurance/cardiovascular-insurance')"
              class="block text-[#121212] hover:text-[#f5375c]">
              {{ "SteadyPulse Insurance" | translate }}
            </a>
          </li>

          <li class="px-4 py-3 hover:bg-[#f9f9f9]">
            <a (click)="onNav('individual-insurance/personal-accident-insurance')"
              class="block text-[#121212] hover:text-[#f5375c]">
              {{ "Personal Accident Insurance" | translate }}
            </a>
          </li>

          <li class="px-4 py-3 hover:bg-[#f9f9f9]">
            <a (click)="onNav('individual-insurance/motor-bike-insurance')"
              class="block text-[#121212] hover:text-[#f5375c]">
              {{ "Bike Insurance" | translate }}
            </a>
          </li>
          <li class="px-4 py-3 hover:bg-[#f9f9f9]">
            <a [routerLink]="['/', lang, 'income-protection-insurance']" routerLinkActive="text-[#ff7394]"
              class="block text-[#121212] hover:text-[#f5375c]">
              {{ "Income Protection Insurance" | translate }}
            </a>
          </li>

          <li class="px-4 py-3 hover:bg-[#f9f9f9]">
            <a [routerLink]="['/', lang, 'car-insurance']" routerLinkActive="text-[#ff7394]"
              class="block text-[#121212] hover:text-[#f5375c]">
              {{ "Car Insurance" | translate }}
            </a>
          </li>

        </ul>
      </li>
      <li
        class="text-[#121212]  not-italic font-medium leading-normal font-[Manrope] cursor-pointer text-sm xl:text-lg transition-colors hover:text-[#f5375c]">
        <a href="https://www.livwell.vn/about-us">{{"About Us" | translate}}</a>
      </li>
      <li
        class="text-[#121212]  not-italic font-medium leading-normal font-[Manrope] cursor-pointer text-sm  xl:text-lg transition-colors hover:text-[#f5375c]">
        <a href="https://www.livwell.vn/blog">{{"Blogs" | translate}}</a>
      </li>
      <a href="https://livwell.app.link/90iNAlNL2Jb?_p=c11130dc9d037af5fc1f8afe" target="_blank"
        rel="noopener noreferrer">
        <button class="flex justify-center items-center text-[#2AD189] text-sm lg:text-lg font-bold leading-normal px-6 py-3 rounded-full border border-[#2AD189] transition-all duration-400  
                                 hover:shadow-[2px_4px_4px_#00000040]
                                 hover:border-[#2AD189]">
          {{ "Download App" | translate }}
        </button>
      </a>
    </ul>
  </div>
  <!-- Mobile Hamburger -->
  <button class="md:hidden flex items-center text-[#121212]" (click)="toggleMenu()">
    <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  </button>
</div>
<!-- Mobile Menu -->
<div *ngIf="menuOpen" class="md:hidden bg-white px-6 py-4 shadow">
  <ul class="flex flex-col gap-4">
    <li
      class="font-[Manrope] text-[#121212] font-[manrope]  not-italic font-medium leading-normal cursor-pointer text-sm xl:text-lg">
      <a (click)="onNav('')" target="_blank" rel="noopener noreferrer">
        {{ "Home" | translate }}
      </a>
    </li>

    <!-- For Business -->
    <li
      class="relative text-[#121212] font-[manrope]  not-italic font-medium leading-normal  font-[Manrope] text-sm xl:text-lg">
      <!-- Parent Link with toggle -->
      <div class="flex justify-between items-center py-2 cursor-pointer hover:text-[#f5375c]"
        (click)="toggleSubmenu('business')">
        {{ "For Business" | translate }}
        <svg class="w-4 h-4 ml-2 transform transition-transform duration-300"
          [class.rotate-180]="activeSubmenu === 'business'" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      <!-- Dropdown -->
      <ul *ngIf="activeSubmenu === 'business'"
        class="mt-2 bg-[#FCC6D0] shadow-lg rounded-lg transition-all duration-300 overflow-hidden">
        <li class="px-4 py-3 hover:bg-[#f9f9f9]">
          <a (click)="onNav('business-insurance')"
            class="block text-[#121212] font-[manrope]  not-italic font-medium leading-normal  hover:text-[#f5375c]">
            {{ "All Solutions for Business" | translate }}
          </a>
        </li>
        <li class="px-4 py-3 hover:bg-[#f9f9f9]">
          <a (click)="onNav('one-health')"
            class="block text-[#121212] font-[manrope]  not-italic font-medium leading-normal  hover:text-[#f5375c]">
            {{ "One Health" | translate }}
          </a>
        </li>
      </ul>
    </li>

    <!-- For Individual -->
    <li
      class="relative text-[#121212] font-[manrope]  not-italic font-medium leading-normal  font-[Manrope] text-sm xl:text-lg">
      <div class="flex justify-between items-center py-2 cursor-pointer hover:text-[#f5375c]"
        (click)="toggleSubmenu('individual')">
        {{ "For Individual" | translate }}
        <svg class="w-4 h-4 ml-2 transform transition-transform duration-300"
          [class.rotate-180]="activeSubmenu === 'individual'" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      <ul *ngIf="activeSubmenu === 'individual'"
        class="mt-2 bg-[#FCC6D0] shadow-lg rounded-lg transition-all duration-300 overflow-hidden">
        <li class="px-4 py-3 hover:bg-[#f9f9f9]">
          <a (click)="onNav('individual-insurance')"
            class="block text-[#121212] font-[manrope]  not-italic font-medium leading-normal  hover:text-[#f5375c]">
            {{ "All Products for Individual" | translate }}
          </a>
        </li>
        <li class="px-4 py-3 hover:bg-[#f9f9f9]">
          <a (click)="onNav('gym-insurance')"
            class="block text-[#121212] font-[manrope]  not-italic font-medium leading-normal  hover:text-[#f5375c]">
            {{ "Gym Insurance" | translate }}
          </a>
        </li>
        <li class="px-4 py-3 hover:bg-[#f9f9f9]">
          <a (click)="onNav('individual-insurance/cardiovascular-insurance')"
            class="block text-[#121212] font-[manrope]  not-italic font-medium leading-normal  hover:text-[#f5375c]">
            {{ "SteadyPulse Insurance" | translate }}
          </a>
        </li>
        <li class="px-4 py-3 hover:bg-[#f9f9f9]">
          <a (click)="onNav('individual-insurance/personal-accident-insurance')"
            class="block ttext-[#121212] font-[manrope]  not-italic font-medium leading-normal  hover:text-[#f5375c]">
            {{ "Personal Accident Insurance" | translate }}
          </a>
        </li>
        <li class="px-4 py-3 hover:bg-[#f9f9f9]">
          <a (click)="onNav('individual-insurance/motor-bike-insurance')"
            class="block text-[#121212] font-[manrope]  not-italic font-medium leading-normal  hover:text-[#f5375c]">
            {{ "Bike Insurance" | translate }}
          </a>
        </li>
        <li class="px-4 py-3 hover:bg-[#f9f9f9]">
          <a [routerLink]="['/', lang, 'income-protection-insurance']" routerLinkActive="text-[#ff7394]"
            class="block text-[#121212] font-[manrope]  not-italic font-medium leading-normal  hover:text-[#f5375c]">
            {{ "Income Protection Insurance" | translate }}
          </a>
        </li>

        <li class="px-4 py-3 hover:bg-[#f9f9f9]">
          <a [routerLink]="['/', lang, 'car-insurance']" routerLinkActive="text-[#ff7394]"
            class="block text-[#121212] font-[manrope]  not-italic font-medium leading-normal  hover:text-[#f5375c]">
            {{ "Car Insurance" | translate }}
          </a>
        </li>

      </ul>
    </li>

    <!-- Other Links -->
    <li
      class="text-[#121212] font-[manrope]  not-italic font-medium leading-normal  font-[Manrope] text-sm xl:text-lg hover:text-[#f5375c]">
      <a href="https://www.livwell.vn/about-us">{{ "About Us" | translate }}</a>
    </li>
    <li
      class="text-[#121212] font-[manrope]  not-italic font-medium leading-normal  font-[Manrope] text-sm xl:text-lg hover:text-[#f5375c]">
      <a href="https://www.livwell.vn/blog">{{ "Blogs" | translate }}</a>
    </li>

    <a href="https://livwell.app.link/90iNAlNL2Jb?_p=c11130dc9d037af5fc1f8afe" target="_blank"
      rel="noopener noreferrer">
      <button
        class="flex justify-center items-center text-[#2AD189] text-sm lg:text-lg font-bold leading-normal px-6 py-3 rounded-full border border-[#2AD189] hover:shadow-[2px_4px_4px_#00000040] hover:border-[#2AD189]">
        {{ "Download App" | translate }}
      </button>
    </a>
  </ul>
</div>